import React, { PureComponent } from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

import './header.scss';

class Header extends PureComponent {
  render() {
    return (
      <div className="heading">
        <div className="background-gradient" />

        <div className="container">
          <Link to={this.props.logoUrl} className="logo">
            Юнисервис Капитал
          </Link>

          {/* <button
            type="button"
            className="btn solid-turq open-navigation-btn"
            onClick={this.props.onNavigationClick}
          >
            <span />
          </button> */}
          {/* <button
            type="button"
            className="btn btn-flex solid-black open-login-btn"
            onClick={this.props.onLoginClick}
          >
            <em>вход<span className="icon">→</span></em>
            Личный кабинет
          </button> */}
        </div>
      </div>
    );
  }
}

Header.propTypes = {
  logoUrl: PropTypes.string,
  onNavigationClick: PropTypes.func,
  onLoginClick: PropTypes.func
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Layout/Header.js